export default (state = {}, action) => {
  switch (action.type) {
    case 'LOGIN':
      return action.auth;
    case 'LOGOUT':
      return {};
    case 'SAVE_USER':
      return {
        ...state,
        authenticated: true,
        user: action.user,
      };
    default:
      return state;
  }
};
